module.exports = __webpack_public_path__ + "static/media/auth-check-user-lock.f2d7d1ac983fae83fa6deae4903c357f.svg";